import Vue3PrintNb from 'vue3-print-nb'

export default {
  install: (app) => {
    app.use(Vue3PrintNb)
    
    // 添加数据处理函数
    const handlePrintData = (columns, tableData) => {
      return tableData.map(row => {
        const newRow = { ...row }
        columns.forEach(col => {
          if (col.formatter) {
            newRow[col.prop] = col.formatter(row[col.prop])
          }
        })
        return newRow
      })
    }

    // 生成打印样式
    const getPrintStyles = () => `
      body { font-family: Arial, sans-serif; }
      .print-container { 
        padding: 20px;
        max-width: 1200px;
        margin: 0 auto;
      }
      .print-title { 
        text-align: center; 
        font-size: 20px; 
        font-weight: bold; 
        margin-bottom: 20px; 
      }
      .print-info {
        text-align: right;
        margin-bottom: 10px;
        font-size: 12px;
        color: #666;
      }
      table { 
        width: 100%; 
        border-collapse: collapse; 
        margin-bottom: 20px;
        table-layout: fixed;
      }
      th, td { 
        border: 1px solid #000; 
        padding: 8px; 
        text-align: center;
        word-break: break-all;
      }
      th { 
        background-color: #f5f7fa; 
        font-weight: bold;
      }
      @media print {
        .no-print { display: none; }
        @page {
          margin: 1cm;
        }
      }
    `
    
    // 添加全局打印方法
    app.config.globalProperties.$printTable = ({
      title = '',
      columns = [],
      tableData = []
    } = {}) => {
      const printData = handlePrintData(columns, tableData)
      const printWindow = window.open('', '_blank')
      const currentTime = new Date().toLocaleString()
      
      const html = `
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8">
            <title>${title}</title>
            <style>${getPrintStyles()}</style>
          </head>
          <body>
            <div class="print-container">
              <div class="print-title">${title}</div>
              <div class="print-info">打印时间：${currentTime}</div>
              <table>
                <thead>
                  <tr>
                    ${columns.map(col => `<th>${col.label}</th>`).join('')}
                  </tr>
                </thead>
                <tbody>
                  ${printData.map(row => `
                    <tr>
                      ${columns.map(col => `<td>${row[col.prop] || ''}</td>`).join('')}
                    </tr>
                  `).join('')}
                </tbody>
              </table>
              <div class="no-print">
                <button onclick="window.print()">打印</button>
                <button onclick="window.close()">关闭</button>
              </div>
            </div>
          </body>
        </html>
      `
      
      printWindow.document.write(html)
      printWindow.document.close()
    }
  }
} 